export default "__VITE_ASSET__CfNaGN6d__"